!function () {
    "use strict";
    var t, e = {
        4105: function (t, e, n) {
            n.d(e, {
                Q2: function () {
                    return o
                },
                gp: function () {
                    return s
                },
                hO: function () {
                    return r
                }
            });
            const o = function () {
                return {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: `application/${arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "json"}`
                    }
                }
            }
                , r = function () {
                    let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    const e = window.innerWidth - document.body.offsetWidth
                        , n = document.getElementById("nav-wrapper");
                    t ? (document.body.classList.add("no-scroll"),
                        document.body.style.paddingRight = e + "px",
                        n.style.paddingRight = e + "px") : (document.body.classList.remove("no-scroll"),
                            document.body.style.paddingRight = "0px",
                            n.style.paddingRight = "0px")
                };
            let a = () => { }
                ;
            const c = t => {
                "Escape" === t.key && (a(),
                    window.removeEventListener("keydown", c))
            }
                , s = function () {
                    let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0]
                        , e = arguments.length > 1 ? arguments[1] : void 0;
                    e && (a = e),
                        t && window.addEventListener("keydown", c),
                        t || window.removeEventListener("keydown", c)
                };
            document.querySelectorAll(".local-scroll").forEach((t => {
                t.addEventListener("click", (t => {
                    t.preventDefault(),
                        t.stopPropagation();
                    const e = t.target.getAttribute("href");
                    (t => {
                        Math.easeInOutQuad = function (t, e, n, o) {
                            return (t /= o / 2) < 1 ? n / 2 * t * t + e : -n / 2 * (--t * (t - 2) - 1) + e
                        }
                            ;
                        const e = document.getElementById("grid-archive-header")
                            , n = document.getElementById("nav-wrapper");
                        let o = 0
                            , r = 0;
                        e && (o = e.offsetHeight + 50),
                            n && (r = n.offsetHeight + 50);
                        const a = t.offsetTop - o - r
                            , c = window.scrollY
                            , s = a - c;
                        let i = 0;
                        const d = () => {
                            i += 5;
                            const t = Math.easeInOutQuad(i, c, s, 200);
                            window.scrollTo(0, t),
                                i < 200 && setTimeout(d, 5)
                        }
                            ;
                        d()
                    }
                    )(document.querySelector(e))
                }
                ))
            }
            ))
        }
    }, n = {};
    function o(t) {
        var r = n[t];
        if (void 0 !== r)
            return r.exports;
        var a = n[t] = {
            exports: {}
        };
        return e[t](a, a.exports, o),
            a.exports
    }
    o.d = function (t, e) {
        for (var n in e)
            o.o(e, n) && !o.o(t, n) && Object.defineProperty(t, n, {
                enumerable: !0,
                get: e[n]
            })
    }
        ,
        o.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e)
        }
        ,
        t = o(4105),
        (() => {
            const e = document.querySelectorAll('form[action="' + window.routes.cartAdd + '"]')
                , n = document.getElementById("main-cart")
                , o = document.getElementById("overlay")
                , r = document.getElementById("mini-cart")
                , a = document.querySelector("cart-service")
                , c = document.querySelector("body")
                , s = () => {
                    r.classList.remove("open"),
                        o.classList.remove("open"),
                        c.style.removeProperty("overflow"),
                        (0,
                            t.hO)(!1)
                }
                ;
            e.length && e.forEach((e => e.addEventListener("submit", (c => {
                c.preventDefault(),
                    c.stopPropagation(),
                    c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addingToCart}`),
                    c.target.querySelector('button[type="submit"]').classList.add("added"),
                    c.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "none",
                    c.target.querySelector('button[type="submit"] > svg.loading-icon').style.display = "block";
                const i = (0,
                    t.Q2)("javascript");
                i.headers["X-Requested-With"] = "XMLHttpRequest",
                    delete i.headers["Content-Type"];
                const d = new FormData(e);
                const formdata_variant_id = e.querySelector('input[name="id"]')?.value;
                d.append("sections", "main-cart"),
                    i.body = d,
                    fetch(`${routes.cartAdd}`, i).then((t => t.json())).then((async e => {
                        // console.log("e.status", e.status);

                        if (e.status) {
                            // console.log("e.status true", e.status);

                            if (c.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "inline-flex",
                                c.target.querySelector('button[type="submit"] > svg.loading-icon').style.display = "none",
                                c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addToCart}`),
                                "object" == typeof e.description)
                                return Object.entries(e.description).forEach((t => {
                                    let [e, n] = t;
                                    const o = `${n.join(", ")}`;
                                    c.target.querySelector(".product-converter__error").innerHTML = '<span class="icon loaded">error</span><p>' + o + "</p>"
                                }
                                ));
                            c.target.querySelector(".product-converter__error").innerHTML = '<span class="icon loaded">error</span><p>' + e.description + "</p>"
                        } else {
                            let mainCartSection = (new DOMParser).parseFromString(e.sections["main-cart"], "text/html");

                            console.log("AUTO ADD mainCartSection", mainCartSection);

                            const auto_add_product = document.querySelector('input[data-auto-add-product]');
                            if (auto_add_product) {
                                console.log("AUTO ADD PRODUCT Found:", auto_add_product);
                                const variant_id = auto_add_product.getAttribute('data-variant');
                                const auto_add_in_cart = mainCartSection.querySelector(`[data-cart-item-variant="${variant_id}"]`);

                                console.log("AUTO ADD auto_add_activated", auto_add_in_cart); 

                                if (variant_id && formdata_variant_id !== variant_id && !auto_add_in_cart) {

                                    console.log("AUTO ADD PRODUCT variant_id:", variant_id);

                                    let formData = {
                                        'items': [{
                                            'id': variant_id,
                                            'quantity': 1
                                        }],
                                        'sections': 'main-cart'
                                    };

                                    try {
                                        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json'
                                            },
                                            body: JSON.stringify(formData)
                                        });
                                        const data = await response.json();
                                        console.log('AUTO ADD PRODUCT Success:', data);
                                        mainCartSection = (new DOMParser).parseFromString(data.sections['main-cart'], "text/html");
                                        
                                    } catch (error) {
                                        console.warn('AUTO ADD PRODUCT Error:', error);
                                    }
                                }
                            }

                            console.log("AUTO ADD PRODUCT Not Found or already in cart:");

                            if ("cart" === cartStrings.uxCart)
                                return void (window.location.href = window.routes.cart);
                            c.target.querySelector(".product-converter__error").innerHTML = "",
                                n && n.classList.add("added"),
                                a.renderItems(mainCartSection),
                                "mini-cart" === cartStrings.uxCart && (r && r.classList.add("open"),
                                    o && (o.classList.add("open", "overlay--all"),
                                        (0,
                                            t.hO)(!0),
                                        (0,
                                            t.gp)(!0, s))),
                                c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addedToCart}`),
                                c.target.querySelector('button[type="submit"]').classList.remove("added"),
                                c.target.querySelector('button[type="submit"]').classList.add("successful"),
                                c.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "flex",
                                c.target.querySelector('button[type="submit"] > svg.loading-icon').style.display = "none"
                        }
                    }
                    )).catch((t => {
                        console.error("Error:", t)
                    }
                    ))
            }
            ))))
        }
        )()
}();
